<template>
    <div class="adaptive-modal-header">
        <div v-if="showHeaderInternal" class="header-main-content">
            <h5 class="adaptive-modal-title">{{ title }}</h5>
            <button v-if="showCloseButtonInternal" type="button" class="btn-close" @click="$emit('close')" aria-label="Close">
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div class="header-extension-slot">
            <slot name="header-extension"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdaptiveModalHeader",
    props: {
        title: {
            type: String,
            required: true,
        },
        showHeaderInternal: {
            type: Boolean,
            default: true,
        },
        showCloseButtonInternal: {
            type: Boolean,
            default: true,
        },
    },
    emits: ["close"],
};
</script>

<style scoped>
.adaptive-modal-header {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border-bottom: 1px solid var(--input-border);
    color: var(--text-primary);
}

.header-main-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.adaptive-modal-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
}

.header-extension-slot {
    margin-top: 0.5rem;
    width: 100%;
}
</style> 